const plan = {
  state: {
    plan: null,
    planDID: null,
    planDIDPrevious: null,
    planDIDCurrent: null
  },
  mutations: {
    changePlan(state, payload) {
      state.plan = payload;
    },
    changePlanDID(state, payload) {
      state.planDID = payload;
    },
    changePlanDIDCurrent(state, payload) {
      state.planDIDCurrent = payload;
    },
    changePlanDIDPrevious(state, payload) {
      state.planDIDPrevious = payload;
    }
  },
  actions: {
    changePlan({ commit }, payload) {
      commit("changePlan", payload);
    },
    changePlanDID({ commit }, payload) {
      commit("changePlanDID", payload);
    },
    changePlanDIDCurrent({ commit }, payload) {
      commit("changePlanDIDCurrent", payload);
    },
    changePlanDIDPrevious({ commit }, payload) {
      commit("changePlanDIDPrevious", payload);
    }
  },
  getters: {
    getPlan: state => {
      return state.plan;
    },
    getPlanDID: state => {
      return state.planDID;
    },
    getPlanDIDCurrent: state => {
      return state.planDIDCurrent;
    },
    getPlanDIDPrevious: state => {
      return state.planDIDPrevious;
    }
  }
};
export default plan;
